import { View, Text } from '@react-pdf/renderer';
import styles from '../../styles';

const Footer = () => (
    <View style={styles.footer} fixed>
        
        <View style={[styles.detailsSubSectionLeft, styles.footerText]}>
            <Text>Term & Conditions:-</Text>
            <Text>
                1) Subject to Ahmedabad Jurisdiction.
            </Text>
            <Text>
                {/* 1) Subject to Ahmedabad Jurisdiction. */}
            </Text>
            <Text>
                {/* 1) Subject to Ahmedabad Jurisdiction. */}
            </Text>
            <Text>
                {/* 1) Subject to Ahmedabad Jurisdiction. */}
            </Text>
            <Text>
                {/* 1) Subject to Ahmedabad Jurisdiction. */}
            </Text>
        </View>
        <View style={styles.detailsSubSectionRight}>
            {/* Upper section */}
            <View style={[styles.footerUpperSection, styles.footerText]}>
                <Text>SOLTRACK TECHNOLOGIES PVT. LTD.</Text>
            </View>
            {/* Lower section */}
            <View style={[styles.footerLowerSection, styles.footerText]}>
                <Text>(Authorised Signatory)</Text>
            </View>
        </View>
    </View>
);

export default Footer;